import React from "react";
import Link from "components/link";
import HighlightMatch from "components/highlight-match";
import getProductUrl from "utils/product-url";
import { useCustomer, useSettings } from "hooks/useStore";
import { trackSelectItem } from "analytics";

const ProductItem = ({ product, query, index }) => {
	const { toggleSearch, toggleMenu, isSearchOpen, isMenuOpen } =
		useSettings(["toggleSearch", "toggleMenu", "isSearchOpen", "isMenuOpen"]);
	const customer = useCustomer();
	const { title, type } = product;

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
		if (isSearchOpen) toggleSearch();
		if (isMenuOpen) toggleMenu();
	};

	return (
		<Link to={getProductUrl(product)} onClick={handleProductClick}
			className="text-base font-base font-normal  md:hidden 
				flex items-center gap-2 flex-wrap search-suggestions-v1">
			<h5 className="text-start line-clamp-2 font-base text-base mb-auto py-0.5">
				<HighlightMatch text={title} query={query} />
			</h5>
			{!title?.toLowerCase().includes(query?.toLowerCase()) &&
			<p className="search-product-type t39b">
				<HighlightMatch text={type} query={query} />
			</p>
			}		</Link>
	);
};

const MobileResults = ({ query, products, totalProducts, handleClick }) => (
	<div className="flex flex-col gap-3 flex-wrap justify-center mt-2 w-full">
		<div className="products-search-results ">
			{products.slice(0, 4).map((product, index) => (
				<ProductItem key={index} product={product} index={index} query={query} />
			))}
		</div>
		{totalProducts - 4 > 0 &&
			<div className="flex gap-5 flex-row-reverse">
				<Link to={`/search?q=${query}`}
					className="flex underline text-xs underline-offset-2 t-search-all-results-click"
					onClick={handleClick}
				>
					Show {totalProducts - 4} more results
				</Link>
			</div>
		}
	</div>
);

export default MobileResults;
